import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/contact/HeroBanner";
import ContactDetails from "../components/contact/ContactDetails";
import ContactFormSec from "../components/contact/ContactFormSec";
// import MapLocation from "../components/contact/MapLocation";


export default function Contact() {
    return (
        <>
            <Header />

            <HeroBanner />

            <ContactDetails />

            <ContactFormSec />

            {/* <MapLocation /> */}

            <Footer />
        </>
    );
}